import { CognitoUserPool } from "amazon-cognito-identity-js";

const {
  VITE_BASE_URL,
  VITE_API_URL,
  VITE_DEFAULT_CACHE_DICTIONARY,
  VITE_DOCUMENT_TITLE,
  VITE_DOCUMENT_ENV,
  MODE,
  VITE_DEFAULT_PATH_AFTER_LOGIN,
  VITE_COGNITO_USER_POOL_ID,
  VITE_COGNITO_CLIENT_ID,
  VITE_GOOGLE_MAPS_API_KEY,
  VITE_API_VERSION,
  VITE_DEFAULT_SELECT_COMPONENT_PAGINATION_LIMIT,
  VITE_PAGINATION_LIMIT_OPTIONS,
  VITE_ENABLE_REACT_QUERY_DEVTOOLS,
  VITE_MAX_FILE_SIZE_MB,
  VITE_EXPORT_TIMEOUT_MS,
  VITE_EXPORT_REFETCH_INTERVAL_MS,
} = import.meta.env ?? process.env;

const userPool = new CognitoUserPool({
  UserPoolId: VITE_COGNITO_USER_POOL_ID,
  ClientId: VITE_COGNITO_CLIENT_ID,
});

let defaultPaginationLimitOptions = [100];

try {
  defaultPaginationLimitOptions = JSON.parse(VITE_PAGINATION_LIMIT_OPTIONS);
} catch (error) {
  console.warn(
    "Invalid VITE_PAGINATION_LIMIT_OPTIONS: expected array with numbers",
    error,
  );
}

const PAGINATION_LIMIT_STORAGE_KEY = "paginationLimit";
const PAGINATION_LIMIT_OPTIONS_STORAGE_KEY = "paginationLimitOptions";

const appConfiguration = {
  userPool,
  baseUrl: VITE_BASE_URL || window.location.origin,
  apiUrl: VITE_API_URL,
  apiVersion: VITE_API_VERSION,
  defaultCacheDictionary: VITE_DEFAULT_CACHE_DICTIONARY,
  documentTitle: VITE_DOCUMENT_TITLE,
  documentEnv: VITE_DOCUMENT_ENV,
  defaultPathAfterLogin: VITE_DEFAULT_PATH_AFTER_LOGIN,
  googleMapsApiKey: VITE_GOOGLE_MAPS_API_KEY,
  enableReactQueryDevtools: VITE_ENABLE_REACT_QUERY_DEVTOOLS === "true",
  maxFileSizeMB: parseInt(VITE_MAX_FILE_SIZE_MB || "5", 10),
  maxFileSizeBytes: parseInt(VITE_MAX_FILE_SIZE_MB || "5", 10) * 1024 * 1024,
  exportTimeoutMs: parseInt(VITE_EXPORT_TIMEOUT_MS || "900000", 10), // 15 minutes in ms
  exportRefetchIntervalMs: parseInt(
    VITE_EXPORT_REFETCH_INTERVAL_MS || "2000",
    10,
  ), // 2 seconds in ms
  get paginationLimitOptions() {
    try {
      const stored = localStorage.getItem(PAGINATION_LIMIT_OPTIONS_STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.every(Number.isFinite)) {
          return parsed as number[];
        }
      }
    } catch {
      // Ignore parse errors — fall back to env defaults
    }
    return defaultPaginationLimitOptions;
  },
  sentryEnv: VITE_DOCUMENT_ENV || MODE,
  // TODO: in the future pagination needs to be set per view, which means
  // we need a huge configuration refactor to allow that.
  get paginationLimit() {
    const options = this.paginationLimitOptions;
    let value;
    try {
      const rawValue = localStorage.getItem(PAGINATION_LIMIT_STORAGE_KEY);
      if (rawValue) {
        value = parseInt(rawValue);
      }
    } catch (error) {
      console.error(error);
    }
    if (value && options.includes(value)) {
      return value;
    }
    return options[0];
  },
  set paginationLimit(value: number) {
    localStorage.setItem(PAGINATION_LIMIT_STORAGE_KEY, value.toString());
  },

  // All selects have their own pagination limit
  selectComponentsPaginationLimit:
    VITE_DEFAULT_SELECT_COMPONENT_PAGINATION_LIMIT ?? 500,
};

export default appConfiguration;
